module.exports = __webpack_public_path__ + "assets/img/99@3x.71ac7300.png";